import What from "../../../pages/assets/toda.png";

export const JumbotronSection = () => {
  return (
    <div class="flex justify-between px-10">
      <div style={{ width: "100%", height: "100%" }}>
        <img src={What} alt="Why Sarvin?" width="100%" height="100%" />
      </div>
    </div>
  );
};
